import { FlowRouter } from 'nove8/FlowRouter'
import { Cohort } from 'nove8/constants/root-constants'
import { useCleanDataByCohortChange } from 'nove8/hooks/useCleanDataByCohortChange'
import { useGetBreedsAndCommands } from 'nove8/hooks/useGetBreedsAndCommands'
import { useGetFirstLead } from 'nove8/hooks/useGetFirstLead'
import { useScrollToTopByRouteChange } from 'nove8/hooks/useScrollToTopByRouteChange'
import { useSetInitialCohort } from 'nove8/hooks/useSetInitialCohort'
import { useSetLanguage } from 'nove8/hooks/useSetLanguage'
import React from 'react'
import { useShallow } from 'zustand/shallow'
import { useZustandStore } from 'zustandGlobalStore'
import { Spinner } from './components/Spinner'
import { useCleanDataByLeadIdChange } from './hooks/useCleanDataByLeadIdChange'
import { useGetDogProfile } from './hooks/useGetDogProfile'
import { useGetDogsProfile } from './hooks/useGetDogsProfile'
import { useGetPlans } from './hooks/useGetPlans'
import { useWoofyInitial } from './hooks/useWoofyInitial'

export const SubscribeFlow: React.FC = () => {
  const { lead, firebaseRemoteConfig } = useZustandStore(
    useShallow((state) => ({
      lead: state.lead,
      firebaseRemoteConfig: state.firebaseRemoteConfig,
    })),
  )

  useGetDogProfile() // new subs
  useGetDogsProfile() // new subs
  useScrollToTopByRouteChange() // new subs
  useSetInitialCohort() // new subs
  useCleanDataByCohortChange() // new subs
  useCleanDataByLeadIdChange() // new subs
  useSetLanguage() // new subs
  useGetFirstLead() // new subs
  useGetBreedsAndCommands() // new subs
  useGetPlans() // new subs
  useWoofyInitial()

  // Woofy flow steps depend on remote config; build the machine only after it loads.
  const isWoofyCohort = lead?.cohort === Cohort.WOOFZ_WOOFY1
  const isFlowConfigReady = !isWoofyCohort || Boolean(firebaseRemoteConfig)

  return lead && isFlowConfigReady ? <FlowRouter /> : <Spinner />
}
